import httpClient, { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import publicHttpClient from '@/services/http/publicHttpClient'

export const apiGetSendOtp = (encSinisterId) => {
  const params = new URLSearchParams()
  params.append('sinisterId', encSinisterId)
  return billmaHttpClient.get(`selfcare/otp${paramsToString(params)}`)
}

export const apiPostValidateOtp = (sinisterId, otpCode) => {
  const params = new URLSearchParams()
  params.append('sinisterId', sinisterId)
  params.append('otp', Number(otpCode))

  return billmaHttpClient.post('selfcare/otp', {
    sinisterId: sinisterId,
    otp: Number(otpCode)
  })
}

export const apiPostValidateAuth = (authCode) => {
  const params = new URLSearchParams()
  params.append('code', authCode)

  return billmaHttpClient.post('selfcare/otpSoggesur', {
    code: authCode
  })
}

export const apiGetToken = () => {
  return httpClient.get('api-token-auth/selfcare/')
}

export const apiGetUser = () => {
  var token = sessionStorage.getItem('mavAuth')
  if (token) {
    token = token.replace('Token', 'Bearer')
  }
  const headers = {
    Authorization: token
  }
  return publicHttpClient.get('api-token-auth/user/', { headers })
}

export const apiGetUserSettings = (sinisterId) => {
  var token = sessionStorage.getItem('mavAuth')
  const headers = {
    Authorization: token
  }
  return publicHttpClient.get(`sinister/user?sinister_id=${sinisterId}`, { headers })
}
